import { createSlice } from "@reduxjs/toolkit";

const name = "captcha";

export type CaptchaState = {
  error: boolean;
  loading: boolean;
  requests: string[];
  token: null | string;
};

export const paginationSlice = createSlice({
  initialState: {
    error: false,
    loading: false,
    requests: [],
    token: null,
  } as CaptchaState,
  name,
  reducers: {
    logRequest({ requests, ...rest }, { payload }: { payload: string }) {
      const nextRequests = new Set(requests);
      nextRequests.add(payload);
      return { ...rest, requests: [...nextRequests] };
    },
    patch(state, { payload }: { payload: Partial<CaptchaState> }) {
      return { ...state, ...payload };
    },
  },
});

export const captcha = paginationSlice.reducer;

export const logRequest = paginationSlice.actions.logRequest;
export const patch = paginationSlice.actions.patch;

/**
 * @see docs/worklog/TW-837-captcha-combo-blocked/rfc.md
 * @see docs/worklog/TW-837-captcha-combo-blocked/tfc.md
 */
